import axios from 'axios'
import Qs from 'qs'
import store from 'STORE/index'
import { pushLogins } from 'ROUTER/index'


import {
  saveAccessToken,
  getAccessToken,
  removeAccessToken,
  cachedAdminInfo,
  cachedWebInfo,
  cachedPublicInfo,
  removeAdminInfo
} from 'API/cacheService'

import {
  SET_ADMIN_INFO,
  SET_WEB_INFO,
  SET_PUBLIC_INFO
} from 'STORE/mutation-types'

/* eslint-disable */
const API_ROOT = 'https://gh.xbjj.com.cn/'
const API_ROOT_DEV = '/a'

/* eslint-enable */
axios.defaults.baseURL = (process.env.NODE_ENV === 'production' ? API_ROOT : API_ROOT_DEV)

axios.defaults.headers.Accept = 'application/json'

// axios拦截器 除登录、注册页面外全部添加token信息
axios.interceptors.request.use(function (config) {
  if (config.url.indexOf('a/') === 0 || config.url.indexOf('w/') === 0) {
    if (getAccessToken()) {
      config.headers['accesstoken'] = getAccessToken()
    }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

// axios拦截器 验证token信息如果没有或者过期返回登录页面
axios.interceptors.response.use(function (response) {
  if (response.data.code < 0) {
    if (response.data.code === -4001) {
      // 清空登录信息、token、跳转登录页
      removeAdminInfo()
      removeAccessToken()
      pushLogins()
    }
    let error = {
      msg: response.data.msg
    }
    return Promise.reject(error)
  }
  return response.data
}, function (error) {
  error = {
    msg: '请求出错'
  }
  return Promise.reject(error)
})

export default {
  /**
   * 用户登录
   */
  webLogin (params) {
    return axios.post('u/login', Qs.stringify(params))
  },
  /**
   * 后台查看用户表单信息收集(分页)
   */
  getUserFormList (params) {
    return axios.post('a/getUserFormList', Qs.stringify(params))
  },
  /**
   * 后台查看表单样式管理(分页)
   */
  getFormStyle (params) {
    return axios.post('a/getFormStyle', Qs.stringify(params))
  },
  /**
   * 删除表单样式
   */
  delFormStyle (params) {
    return axios.post('a/delFormStyle', Qs.stringify(params))
  },
  /**
   * 添加表单样式
   */
  addFormStyle (params) {
    return axios.post('a/addFormStyle', Qs.stringify(params))
  },
  /**
   * 获取单个表单样式
   */
  getFormStyleData (params) {
    return axios.post('a/getFormStyleData', Qs.stringify(params))
  },
  /**
   * 修改单个表单样式
   */
  upFormStyleData (params) {
    return axios.post('a/upFormStyleData', Qs.stringify(params))
  },
  /**
   * 获取业务员数据（分页）
   */
  getSalesman (params) {
    return axios.post('a/getSalesman', Qs.stringify(params))
  },
  /**
   * 删除业务员数据
   */
  delSalesman (params) {
    return axios.post('a/delSalesman', Qs.stringify(params))
  },
  /**
   * 添加业务员数据
   */
  addSalesman (params) {
    return axios.post('a/addSalesman', Qs.stringify(params))
  },
  /**
   * 修改业务员数据
   */
  upSalesmanData (params) {
    return axios.post('a/upSalesmanData', Qs.stringify(params))
  },
  /**
   * 获取业务员数据
   */
  getSalesmanData (params) {
    return axios.post('a/getSalesmanData', Qs.stringify(params))
  },
  /**
   * 获取后台首页必要数据
   */
  getHomeData (params) {
    return axios.post('a/getHomeData', Qs.stringify(params))
  },
  /**
   * 链接生成页面数据获取
   */	
  getLinkData (params) {
    return axios.post('a/getLinkData', Qs.stringify(params))
  },
  /**
   * 注销，退出系统
   */	
  exitlogin (params) {
    return axios.post('a/exitlogin', Qs.stringify(params))
  },
}


// WEBPACK FOOTER //
// ./src/api/index.js